import type { SvgIconProps } from 'types/icon';
import Info from '@mui/icons-material/Info';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import InfoRounded from '@mui/icons-material/InfoRounded';

export const InfoIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Info color={color} {...props} />
);

export const InfoOutlinedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <InfoOutlined color={color} {...props} />;

export const InfoRoundedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <InfoRounded color={color} {...props} />;
